// import { DebugBox } from "@northpowerdev/np-react-utils"
import { safeFormatDate, toTitleCase } from "../../../utils/utilityFunctions"
import { DlspLinks } from "./DlspLinks"
import { DlspStatusHistory } from "./DlspStatusHistory"

const { Grid, Box, Typography } = require("@mui/material")
const { DlspTable } = require("./DlspTable")
const { DlspNotes } = require("./DlspNotes")

export function DlspTaskDetailsPanel({taskDetails, fspStatusNoEdit, readOnlyStyling}) {
    if (!taskDetails) {
        return null
    }

    const leftTableRows = []
    if (taskDetails) {
        leftTableRows.push({label: 'ICP',                      text: taskDetails.decomICP.icp                      || "--"})
        leftTableRows.push({label: 'DSub Suburb',              text: taskDetails.odsDSub?.suburb                    || "--"})
        leftTableRows.push({label: 'Address Notes',            text: taskDetails.decomICP.addressNotes             || "--"})
        leftTableRows.push({label: 'Registry Status',          text: <RegistryStatusCell statusHistory={taskDetails.statusHistory} />})
    }

    const middleTableRows = []
    if (taskDetails) {
        middleTableRows.push({label: 'ICP Orientation',          text: taskDetails.decomICP.icpOrientation           || "--"})
        middleTableRows.push({label: 'LV Orientation',           text: taskDetails.decomICP.lvOrientation            || "--"})
        middleTableRows.push({label: 'Installation Orientation', text: taskDetails.decomICP.installationOrientation  || "--"})
        middleTableRows.push({label: 'LV Conductor Orientation', text: taskDetails.decomICP.lvCondOrientation        || "--"})
        middleTableRows.push({label: 'Nearest LV Orientation',   text: taskDetails.decomICP.nearestLvOrientation     || "--"})
    }

    const rightTableRows = []
    if (taskDetails) {
        rightTableRows.push({label: 'Premise Type',             text: taskDetails.decomICP.premiseType              || "--"})
        rightTableRows.push({label: 'Flag',                     text: taskDetails.decomICP.flag                     || "--"})
        rightTableRows.push({label: 'DSub',                     text: taskDetails.odsDSub?.dSubNumber               || "--"})
    }
    return (
        <Grid container sx={{my: 2, ...(fspStatusNoEdit && readOnlyStyling)}} spacing={2}  >
            <Grid item md={4}>
                <DlspTable rows={leftTableRows} skipHeader={true} />
            </Grid>
            <Grid item md={4}>
                <DlspTable rows={middleTableRows} skipHeader={true} />
            </Grid>
            <Grid item md={4}>
                <DlspTable rows={rightTableRows} skipHeader={true} />
            </Grid>

            <Grid item md={6}>
                <Box sx={{my: 2}}>
                    <DlspNotes notes={taskDetails.decomICP.notes} />
                    <DlspStatusHistory statusHistory={taskDetails.statusHistory} />
                </Box>
            </Grid>

            <Grid item md={4}>
                <Box sx={{my: 2}}>
                    <DlspLinks taskDetails={taskDetails} />
                </Box>
            </Grid>
            
         </Grid>
    )
}

function RegistryStatusCell({statusHistory}) {

    if (!statusHistory?.length) {
        console.log('RegistryStatusCell no length')
        return null
    }
    let currentRegistryStatus
    console.log('RegistryStatusCell', statusHistory)
    currentRegistryStatus = statusHistory[statusHistory.length - 1]
    const statusAndReason = [toTitleCase(currentRegistryStatus?.status), currentRegistryStatus?.reason, safeFormatDate(currentRegistryStatus?.startDate)]

    return (
        <Box>
            {
                statusAndReason.map((s, index) => {
                    return (
                        <span key={index}>{s}<br /></span>
                    )
                })
            }
            {
                currentRegistryStatus?.startDate > '2021-11-01'
                &&
                <Typography variant="body2" color="secondary"><em>This ICP was recently active.</em></Typography>
            }
        </Box>
    )
}